<app-tabs-filter>
  @for (facet of facets(); track facet.id) {
    <button
      [style.cursor]="isDetaied() ? 'default' : 'pointer'"
      class="button" appButton type="button" (click)="onSelected(facet)" [color]="getFacetColor(facet)"
            [class]="getButtonClass(facet)" [noSpaces]="true">
      <app-icon icon [color]="selectedFacet() === facet.alias ? '#ffffff' : '#063DA9'" [name]="getFacetIcon(facet)" size="medium"></app-icon>
      <span [class]="getFacetName(facet) ? 'ml-2': ''">
      {{ getFacetName(facet) }}
    </span>
    </button>
  }
</app-tabs-filter>


@if (!isDetaied() && !isPreviewMode() && !hideDescription() && withDescription()) {
<div class="facet-description">
  @if (!!getFacetNameByAlias(selectedFacet())) {
    <p class="font-bold text-base">* {{ getFacetNameByAlias(selectedFacet()) }}</p>
    <p class="text-gray ml-3">Chronicles {{ getFacetNameByAlias(selectedFacet())?.toLowerCase() }} you had throughout
      your
      life,
      highlighting
      their importance and
      the joy they bring</p>
  }
</div>
}
